export default "__VITE_ASSET__35c1283e__"